import { requestGet } from '../../utils/request';
import { getRootUrl } from '../../utils/url';

const SERVICE_ENDPOINT = '/api/eva/api/v1/operation';

/**
 * Get all operations for user
 * @param {string} userId the user's id.
 * @return {Promise} Response
 */
export function fetchOperations(userId) {
  const url = `${getRootUrl()}${SERVICE_ENDPOINT}?farmInfo=false`;
  return requestGet(url, {
    headers: { 'X-user-id': userId },
    mockFile: 'operations'
  }).then(response => response.json());
}
